import { get } from 'lodash';

/**
 * Parses a valid response from a secure messages count response to
 * retrieve the count of new messages for the current User.
 * @param {*} response
 * @returns {number}
 */
export function parseMessageCountResponse(response) {
  /** Should we fail to get the number of "NEW" messages, return 0 */
  return get(response, 'meta.count_by_status.NEW', 0);
}
